import { useDispatch } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import { usePopupState } from 'material-ui-popup-state/hooks';
import { ConfigurationT } from 'components/ui-new/customization-configuration-popup/types';

type Props = {
  shouldFetch?: boolean;
  data: ConfigurationT[];
  onPopupOpen?: () => void;
};

const useCustomizationConfigurationPopup = ({ onPopupOpen, data }: Props) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);

  const rootRef = useRef<HTMLDivElement>(null);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const popupState = usePopupState({ variant: 'popover', popupId: `customization-info` });

  const shouldFetch = data.length === 0;

  useEffect(() => {
    if (isOpen && shouldFetch && onPopupOpen) {
      onPopupOpen();
    }
  }, [isOpen, onPopupOpen, shouldFetch]);

  return {
    isOpen,
    rootRef,
    popupState,
    textareaRef,
    dispatch,
    setIsOpen,
  };
};

export default useCustomizationConfigurationPopup;
